import Role from './Role'

export default Role


// WEBPACK FOOTER //
// ./src/yxyweb/common/components/role/index.jsx